import styled from 'styled-components'

export const Content = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
  margin-top: 15px;
  font-family: 'Inter', sans-serif;
  box-sizing: border-box;
`

export const TableContainer = styled.div`
  flex: 1;
  min-height: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding-right: 10px;
  box-sizing: border-box;

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #c0c0c0;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    border-radius: 10px;
    border: 2px solid #c0c0c0;
  }
`

export const LoadingMessage = styled.p`
  display: flex;
  justify-content: center;
  text-align: center;
  background-color: #f5f5f5;

  img {
    width: 50px;
    margin-top: 30vh;
  }
`
